import { useWindowSize } from '@uidotdev/usehooks';
import { useTranslation } from 'react-i18next';
import { useSnapshot } from 'valtio';

import { useTheme } from '@mui/material/styles';

import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';

import SearchIcon from '@mui/icons-material/Search';

import {
  MonthRangePicker,
  ReeferAgesSelectFilter,
  TemperaturesSelectFilter,
  TradelanesSelectFilter,
  store,
} from '@/components/pages/EmissionsDashboard';

import { appStore } from '@/store';

import { MapPaper } from '../MapPaper';

import { RefrigerationUnitModelsFilterList } from './RefrigerationUnitModelsFilterList';

function FiltersPanel() {
  const { t } = useTranslation();
  const theme = useTheme();

  const windowSize = useWindowSize();

  const appSnap = useSnapshot(appStore);
  const snap = useSnapshot(store);

  const height = windowSize.height
    ? windowSize.height - appSnap.appBar.height
    : 0;

  return (
    <MapPaper
      tooltip="Filters"
      sx={{
        width: 350,
        height: height - parseFloat(theme.spacing(8)),
        top: 0,
        left: 0,
      }}
      title={t('filters.filters')}
      icon={<SearchIcon />}
      buttonSx={{
        m: 2,
      }}
    >
      <Stack direction="column" spacing={2} sx={{ pt: 1 }}>
        <MonthRangePicker />
        <TemperaturesSelectFilter />
        <ReeferAgesSelectFilter />
        <TradelanesSelectFilter />
        <Divider />
        <RefrigerationUnitModelsFilterList />
      </Stack>
    </MapPaper>
  );
}

export { FiltersPanel };
